export type ThemeValue = 'light' | 'dark' | 'system'

export function applyTheme(theme: ThemeValue) {
  const html = document.documentElement
  html.classList.remove('light', 'system')
  if (theme === 'light') html.classList.add('light')
  if (theme === 'system') html.classList.add('system')
  localStorage.setItem('theme', theme)
}
